export const BREAKPOINT_DESKTOP = 769;
export const MAX_MOBILE = 450;
